var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "svg",
    {
      attrs: {
        width: "39",
        height: "39",
        viewBox: "0 0 39 39",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
      },
    },
    [
      _c("circle", {
        attrs: {
          cx: "19.5",
          cy: "19.5",
          r: "19",
          fill: "white",
          "fill-opacity": "0.2",
          stroke: "url(#paint0_linear)",
        },
      }),
      _c("path", {
        attrs: {
          d: "M26.5478 15.0938H25.7195C25.6166 13.5528 24.9361 12.1086 23.8155 11.0529C22.6949 9.99714 21.2177 9.40864 19.6824 9.40625H18.4709C16.9356 9.40864 15.4584 9.99714 14.3378 11.0529C13.2172 12.1086 12.5367 13.5528 12.4338 15.0938H12.0093C11.9022 15.0938 11.7995 15.1366 11.7238 15.2127C11.648 15.2889 11.6055 15.3923 11.6055 15.5V27.6875C11.6061 28.226 11.8191 28.7423 12.1976 29.1231C12.5761 29.5039 13.0894 29.7181 13.6247 29.7188H24.9324C25.4677 29.7181 25.981 29.5039 26.3595 29.1231C26.738 28.7423 26.951 28.226 26.9516 27.6875V15.5C26.9516 15.3923 26.9091 15.2889 26.8333 15.2127C26.7576 15.1366 26.6549 15.0938 26.5478 15.0938ZM18.4709 10.2188H19.6824C21.0038 10.2209 22.2758 10.7238 23.245 11.6273C24.2142 12.5308 24.8093 13.7685 24.9118 15.0938H13.2414C13.3439 13.7685 13.9391 12.5308 14.9083 11.6273C15.8774 10.7238 17.1495 10.2209 18.4709 10.2188ZM17.6632 17.5312C17.2347 17.5312 16.8239 17.7025 16.5209 18.0072C16.218 18.3119 16.0478 18.7253 16.0478 19.1562V21.5938C16.0478 21.8092 15.9627 22.0159 15.8112 22.1683C15.6597 22.3206 15.4543 22.4062 15.2401 22.4062C15.0259 22.4062 14.8204 22.3206 14.669 22.1683C14.5175 22.0159 14.4324 21.8092 14.4324 21.5938V15.9062H20.8939V19.9688C20.8939 20.1842 20.8088 20.3909 20.6574 20.5433C20.5059 20.6956 20.3005 20.7812 20.0862 20.7812C19.872 20.7812 19.6666 20.6956 19.5151 20.5433C19.3636 20.3909 19.2785 20.1842 19.2785 19.9688V19.1562C19.2785 18.7253 19.1084 18.3119 18.8054 18.0072C18.5025 17.7025 18.0916 17.5312 17.6632 17.5312ZM12.4132 15.9062H13.6247V17.5312H12.4132V15.9062ZM26.1439 27.6875C26.1439 28.0107 26.0163 28.3207 25.7891 28.5493C25.5619 28.7778 25.2537 28.9062 24.9324 28.9062H13.6247C13.3034 28.9062 12.9952 28.7778 12.768 28.5493C12.5408 28.3207 12.4132 28.0107 12.4132 27.6875V18.3438H13.6247V21.5938C13.6247 22.0247 13.7949 22.4381 14.0978 22.7428C14.4008 23.0475 14.8117 23.2188 15.2401 23.2188C15.6685 23.2188 16.0794 23.0475 16.3823 22.7428C16.6853 22.4381 16.8555 22.0247 16.8555 21.5938V19.1562C16.8555 18.9408 16.9406 18.7341 17.092 18.5817C17.2435 18.4294 17.4489 18.3438 17.6632 18.3438C17.8774 18.3438 18.0828 18.4294 18.2343 18.5817C18.3858 18.7341 18.4709 18.9408 18.4709 19.1562V19.9688C18.4709 20.3997 18.641 20.8131 18.944 21.1178C19.2469 21.4225 19.6578 21.5938 20.0862 21.5938C20.5147 21.5938 20.9255 21.4225 21.2285 21.1178C21.5314 20.8131 21.7016 20.3997 21.7016 19.9688V18.3438H26.1439V27.6875ZM26.1439 17.5312H21.7016V15.9062H26.1439V17.5312Z",
          fill: "white",
        },
      }),
      _c(
        "defs",
        [
          _c(
            "linearGradient",
            {
              attrs: {
                id: "paint0_linear",
                x1: "19.5",
                y1: "0",
                x2: "19.5",
                y2: "39",
                gradientUnits: "userSpaceOnUse",
              },
            },
            [
              _c("stop", {
                attrs: { "stop-color": "white", "stop-opacity": "0" },
              }),
              _c("stop", { attrs: { offset: "1", "stop-color": "white" } }),
            ],
            1
          ),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }